import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=361d8478&"
import script from "./NoticeBar.vue?vue&type=script&lang=ts&"
export * from "./NoticeBar.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports